var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('page-view',[_c('section',{attrs:{"slot":"content"},slot:"content"},[_vm._v(" ВЫ в ЛК "+_vm._s(_vm.$store.getters.activeUser)+" "+_vm._s(_vm.$store.getters.token)+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }